import { Card, Skeleton, Row, Col } from "antd";
import { FaFileAlt, FaUsers, FaFolderOpen, FaTasks } from "react-icons/fa";

export default function StatsCards({ stats, loading = false }) {
  const topUsuarios = Object.entries(stats.archivosPorUsuario || {})
    .sort(([, a], [, b]) => b - a)
    .slice(0, 1);

  const topTipos = Object.entries(stats.archivosPorTipo || {})
    .sort(([, a], [, b]) => b - a)
    .slice(0, 1);

  const cardStyle = {
    width: 250,
    height: 150,
    display: "flex",
    
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 12,
    transition: "all 0.3s ease",
    cursor: "pointer",
  };

  const iconStyle = { fontSize: 30, color: "#1890ff", marginBottom: 8 };

  if (loading) {
    return (
      <Row gutter={[16, 16]} wrap={false}>
        {[...Array(4)].map((_, i) => (
          <Col key={i}>
            <Card style={cardStyle}>
              <Skeleton active paragraph={{ rows: 3 }} />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <Row gutter={[16, 16]} wrap={false}>
    {/* Total de Archivos */}
    <Col>
        <Card
            style={cardStyle}
            hoverable
            styles={{ body: { display: "flex", flexDirection: "column", alignItems: "center" } }}
        >
            <FaFileAlt style={iconStyle} />
            <div className="text-2xl font-bold" style={{ fontWeight: "bold", fontSize: 12 }}>{stats.totalArchivos}</div>
            <div className="text-sm text-gray-500 mt-1 text-center font-bold" style={{ fontWeight: "bold", fontSize: 14 }}>Archivos en total</div>
        </Card>
    </Col>

    {/* Usuarios Activos */}
      <Col>
        <Card
          style={cardStyle}
          hoverable
          styles={{ body: { display: "flex", flexDirection: "column", alignItems: "center" } }}
        >
          <FaUsers style={iconStyle} />
          <div className="text-2xl font-bold"  style={{ fontWeight: "bold", fontSize: 12 }}>{Object.keys(stats.archivosPorUsuario || {}).length}</div>
          <div className="text-sm text-gray-500 mt-1 text-center"  style={{ fontWeight: "bold", fontSize: 14 }}>
            {topUsuarios.length > 0
              ? `N° Usuarios`
              : "Sin usuarios"}
          </div>
        </Card>
      </Col>

      {/* Tipos de Archivo */}
      <Col>
        <Card
          style={cardStyle}
          hoverable
          styles={{ body: { display: "flex", flexDirection: "column", alignItems: "center" } }}
        >
          <FaFolderOpen style={iconStyle} />
          <div className="text-2xl font-bold"  style={{ fontWeight: "bold", fontSize: 12 }}>{Object.keys(stats.archivosPorTipo || {}).length}</div>
          <div className="text-sm text-gray-500 mt-1 text-center"  style={{ fontWeight: "bold", fontSize: 14 }}>
            Tipos de archivo
          </div>
        </Card>
      </Col>

      {/* Estados */}
      <Col>
        <Card
          style={cardStyle}
          hoverable
          styles={{ body: { display: "flex", flexDirection: "column", alignItems: "center" } }}
        >
          <FaTasks style={iconStyle} />
          <div className="text-2xl font-bold"  style={{ fontWeight: "bold", fontSize: 12 }}>{Object.keys(stats.archivosPorEstado || {}).length}</div>
          <div className="text-sm text-gray-500 mt-1 text-center"  style={{ fontWeight: "bold", fontSize: 14 }}>Estados diferentes</div>
        </Card>
      </Col>
    </Row>
  );
}
